'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Resume = require('./Resume');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Resume).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Resume/index.js
// module id = 1276
// module chunks = 1